import { APPLICATION_STATUS } from '@/constants/applications'
import { TApplication } from '@/interfaces'
import { useMemo } from 'react'
import ChangeStatusOption from './option'

import './index.scss'
import { OfflineState } from '@/state/offline-management'
import { AuthState } from '@/state'

export default function ChangeApplicationStatus({
  application,
  loading,
}: {
  application: TApplication
  loading?: boolean
}) {
  const currentApplicationStatus = application.estadoName

  const { nextStatus, hasNextStatus, isAutoUpdate } = useMemo(() => {
    const applicationStatusInfo = APPLICATION_STATUS.find(
      (item) => item.value === currentApplicationStatus
    )

    const nextStatus =
      applicationStatusInfo?.nextStatus.filter((item) =>
        AuthState.statusChangeAllowed.value.includes(item)
      ) ?? []

    return {
      applicationStatusInfo,
      hasNextStatus: Boolean(
        applicationStatusInfo && (nextStatus?.length || 0) > 0
      ),
      isAutoUpdate: applicationStatusInfo?.nextStatusAuto ?? false,
      nextStatus,
    }
  }, [currentApplicationStatus, AuthState.statusChangeAllowed.value])

  const isOffline = !OfflineState.isOnline.value

  if (
    !hasNextStatus ||
    isAutoUpdate ||
    isOffline
    // !AuthState.applicationPermission.value.edit
  )
    return null

  return (
    <div className='change-status'>
      {nextStatus.map((item) => (
        <ChangeStatusOption
          key={item}
          statusOption={item}
          applicationInfo={application}
          loading={loading}
        />
      ))}
    </div>
  )
}
